import * as t from 'io-ts';
import { FUNCTIONS_ERROR_CODE_KEYS } from "../../types/CallResponse";

export const FunctionsErrorCodeCodec = t.keyof(FUNCTIONS_ERROR_CODE_KEYS);

export const CallResponseSchema = t.intersection([
    t.type({
        code: FunctionsErrorCodeCodec,
        message: t.string
    }),
    t.partial({
        data: t.any,
        details: t.unknown
    }),
]);

export const CallResponseSchemaNoData = t.intersection([
    t.type({
        code: FunctionsErrorCodeCodec,
        message: t.string
    }),
    t.partial({
        details: t.unknown
    })
]);

export const CallResponseMixinSchema = t.intersection([
    t.type({
        code: FunctionsErrorCodeCodec,
        message: t.string
    }),
    t.partial({
        details: t.unknown
    })
]);